import { type ReactNode, createContext, useContext, useState } from 'react';

type Props = {
  hovered: string | null;
  setHovered: (id: string | null) => void;
  onClick: (id: string) => void;
};

const defaultValue = {
  hovered: null,
  setHovered: () => console.error('No provider for InteractionContext'),
  onClick: () => console.error('No provider for InteractionContext'),
};

const InteractionContext = createContext<Props>(defaultValue);

export const InteractionContextProvider = ({
  children,
  onClick,
}: {
  onClick: (id: string) => void;
  children: ReactNode;
}) => {
  const [hovered, setHovered] = useState<string | null>(null);
  return (
    <InteractionContext.Provider
      value={{
        hovered,
        setHovered,
        onClick,
      }}
    >
      {children}
    </InteractionContext.Provider>
  );
};

export const useInteraction = () => {
  const context = useContext(InteractionContext);
  if (context === defaultValue) {
    throw new Error('useInteraction must be used within a InteractionContextProvider');
  }
  return context;
};
export const useIsInteractive = () => {
  const context = useContext(InteractionContext);
  return context !== defaultValue;
};
